import React from 'react'

export default function CMOnlyComponent() {
  return <div>This component may only be used in Geneva CM!</div>
}
